module.exports = __webpack_public_path__ + "img/dots.7f626cc1.svg";